import {
    getHeaders,
    getStorage,
    getOptionsOnlyOutput
} from '../../lib/skycity.js'

export async function getConfigSplitView (curFile, outputOptions, inputSecondFiles) {
    const payload = await getCodePayload(curFile, outputOptions, inputSecondFiles)
    const config = {
        url: `${process.env.REACT_APP_CONFIG_ENDPOINT_PIE}/psdService/splitView`,
        method: 'POST',
        timeout: 180000,
        // timeout: 5000,
        headers: getHeaders(),
        payload: payload,
        body: JSON.stringify(payload)
    }
    return config
}

export async function getConfigSideBySide (curFile, outputOptions, inputSecondFiles) {
    const payload = await getCodePayload(curFile, outputOptions, inputSecondFiles)
    const config = {
        url: `${process.env.REACT_APP_CONFIG_ENDPOINT_PIE}/psdService/sideBySide`,
        method: 'POST',
        timeout: 180000,
        // timeout: 5000,
        headers: getHeaders(),
        payload: payload,
        body: JSON.stringify(payload)
    }
    return config
}

async function getCodePayload (curFile, outputOptions, curSecondFile) {
    const codePayload = {
        inputs: [
            {
                href: curFile.path,
                storage: getStorage(curFile)
            },
            {
                href: curSecondFile.path || curSecondFile.href,
                storage: getStorage(curSecondFile)
            }
        ],
        outputs: await getOptionsOnlyOutput(curFile, outputOptions)
    }
    return codePayload
}
